import { FC } from 'react';
import { EDuplicateEntityType } from 'data/types/duplicateManagement.types';
import DuplicatePairList from '../../components/DuplicatePairList';

const PeopleTab: FC = () => (
  <DuplicatePairList entityType={EDuplicateEntityType.PEOPLE} />
);

export default PeopleTab;
